import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@urc-ui/store/types';

export type AdsAgentChatState = {
  advertiserIds: string[];
  managerAccountIds: string[];
  campaignIds: string[];
};

const initialState: AdsAgentChatState = {
  advertiserIds: [],
  managerAccountIds: [],
  campaignIds: []
};

const adsAgentChatSlice = createSlice({
  name: 'adsAgentChat',
  initialState,
  reducers: {
    setAdvertisersFilter: (state, action: PayloadAction<string[]>) => {
      state.advertiserIds = action.payload;
    },
    setManagerAccountsFilter: (state, action: PayloadAction<string[]>) => {
      state.managerAccountIds = action.payload;
    },
    setCampaignIdsFilter: (state, action: PayloadAction<string[]>) => {
      state.campaignIds = action.payload;
    }
  }
});

export const { setAdvertisersFilter, setManagerAccountsFilter, setCampaignIdsFilter } = adsAgentChatSlice.actions;

export const selectAdvertisersFilter = (state: RootState): string[] => state.adsAgentChat.advertiserIds;
export const selectManagerAccountsFilter = (state: RootState): string[] => state.adsAgentChat.managerAccountIds;
export const selectCampaignIdsFilter = (state: RootState): string[] => state.adsAgentChat.campaignIds;

export default adsAgentChatSlice.reducer;
